import { z } from 'zod';

/** B-A.1 — Locale enum (ru base, en MVP; kk/zh — scaffold готов, переводы по запросу). */
export const Locale = z.enum(['ru', 'en', 'kk', 'zh']);
export type Locale = z.infer<typeof Locale>;

/** BCP 47 tag для Intl.NumberFormat / Intl.DateTimeFormat / Paraglide runtime. */
export const LOCALE_BCP47: Record<Locale, string> = {
  ru: 'ru-RU',
  en: 'en-US',
  kk: 'kk-KZ',
  zh: 'zh-CN',
};

/**
 * Fallback chain (policy).
 * Если ключ отсутствует в текущем locale, тянем из следующего по цепочке.
 *
 * ru: базовый, fallback не нужен.
 * en: en-miss → ru (STAITER стартовал как ru-first).
 * kk: bilingual — ru привычнее, чем en.
 * zh: en — lingua franca IT, ru — последний.
 */
export const FALLBACK_CHAIN: Record<Locale, Locale[]> = {
  ru: [],
  en: ['ru'],
  kk: ['ru'],
  zh: ['en', 'ru'],
};

export const SUPPORTED_LOCALES: readonly Locale[] = ['ru', 'en', 'kk', 'zh'] as const;
